(() => {
  function connectModelSearch(root, options = {}) {
    root.querySelectorAll('[data-nav-model-group]').forEach((group) => {
      const input = group.querySelector('[data-nav-model-search]');
      const items = [...group.querySelectorAll('[data-nav-model-item]')];
      const status = group.querySelector('[data-nav-model-status]');
      const empty = group.querySelector('[data-nav-model-empty]');
      if (!input || !items.length) return;
      const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      const titles = items.map((item) => normalize(item.dataset.modelTitle));
      input.addEventListener('input', () => {
        const words = normalize(input.value.trim()).split(/\s+/).filter(Boolean);
        let matches = 0;
        items.forEach((item, index) => {
          item.hidden = !words.every((word) => titles[index].includes(word));
          if (!item.hidden) matches++;
        });
        empty.hidden = !words.length || matches > 0;
        status.textContent = words.length ? input.dataset.countText.replace('{{ count }}', String(matches)) : '';
      }, options);
    });
  }

  class RivalNavMenu extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      connectModelSearch(this, options);
      this.details = this.querySelector('details');
      this.summary = this.details.querySelector('summary');
      this.buttons = [...this.querySelectorAll('[data-nav-category]')];
      this.panels = [...this.querySelectorAll('[data-nav-panel]')];
      const select = (button) => {
        this.buttons.forEach((item) => {
          const selected = item === button;
          item.setAttribute('aria-expanded', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.navPanel !== button.dataset.navCategory; });
        this.sizeVehiclePanel();
      };
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button), options);
        button.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % this.buttons.length;
          if (event.key === 'ArrowUp') next = (index - 1 + this.buttons.length) % this.buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(this.buttons[next]);
          this.buttons[next].focus();
        }, options);
      });
      if (this.buttons.length) select(this.buttons[0]);
      this.classList.add('rival-nav--ready');
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      this.summary.addEventListener('click', (event) => {
        if (event.detail > 0 && this.openedByHover && this.details.open) event.preventDefault();
        this.openedByHover = false;
      }, options);
      this.details.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) this.sizeVehiclePanel();
        if (this.details.open) document.querySelectorAll('rival-nav-menu').forEach((menu) => { if (menu !== this) menu.close(); });
      }, options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || this.dataset.trigger !== 'hover') return;
        clearTimeout(this.closeTimer);
        this.openedByHover = !this.details.open;
        this.details.open = true;
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse' || this.dataset.trigger !== 'hover') return;
        this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 160);
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.close();
          this.summary.focus();
        }
      }, options);
      this.addEventListener('focusout', (event) => { if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(); }, options);
      document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) this.close(); }, options);
      window.addEventListener('resize', () => { if (window.innerWidth < 1024) this.close(); else this.sizeVehiclePanel(); }, options);
    }
    sizeVehiclePanel() {
      if (!this.details?.open || !this.details.classList.contains('rival-nav__details--vehicle')) return;
      cancelAnimationFrame(this.sizeFrame);
      this.sizeFrame = requestAnimationFrame(() => {
        const dropdown = this.details.querySelector('.rival-nav__panel');
        const boundary = dropdown.offsetParent;
        if (boundary) {
          const bounds = boundary.getBoundingClientRect();
          const trigger = this.summary.getBoundingClientRect();
          const rtl = getComputedStyle(boundary).direction === 'rtl';
          const start = rtl ? bounds.right - trigger.right : trigger.left - bounds.left;
          this.style.setProperty('--rival-vehicle-menu-start', `${Math.max(0, start)}px`);
        }
        const panel = this.panels.find((item) => !item.hidden);
        if (!panel) return;
        const container = panel.parentElement;
        const style = getComputedStyle(container);
        const height = panel.scrollHeight + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        this.style.setProperty('--rival-vehicle-menu-height', `${Math.min(460, Math.max(280, height))}px`);
      });
    }
    close() { clearTimeout(this.closeTimer); this.openedByHover = false; if (this.details) this.details.open = false; }
    disconnectedCallback() { clearTimeout(this.closeTimer); cancelAnimationFrame(this.sizeFrame); this.controller?.abort(); }
  }
  if (!customElements.get('rival-nav-menu')) customElements.define('rival-nav-menu', RivalNavMenu);

  let finderObserver;
  function connectVehicle() {
    finderObserver?.disconnect();
    const root = document.querySelector('[data-rival-vehicle-finder][data-indicator="true"][data-initialized="true"]');
    if (!root) return;
    const labels = document.querySelector('.rival-nav');
    document.body.classList.add('rival-garage-refined');
    const sync = () => {
      const active = root.querySelector('[data-rival-active]');
      const selected = active && !active.hidden;
      const label = root.querySelector('[data-rival-active-label]')?.textContent.trim();
      document.querySelectorAll('[data-nav-vehicle-label]').forEach((node) => {
        const value = selected && label ? label : node.dataset.emptyLabel;
        if (node.textContent !== value) node.textContent = value;
      });
      document.querySelectorAll('[data-nav-vehicle-action][data-choose-label]').forEach((node) => {
        const value = selected ? node.dataset.changeLabel : node.dataset.chooseLabel;
        if (node.textContent !== value) node.textContent = value;
      });
      root.querySelectorAll('.rival-garage__vehicle').forEach((vehicle) => {
        const use = vehicle.querySelector('[data-rival-garage-use]');
        const current = vehicle.querySelector('[data-rival-garage-current]');
        if (use && labels?.dataset.garageUseLabel && use.textContent !== labels.dataset.garageUseLabel) use.textContent = labels.dataset.garageUseLabel;
        if (current && vehicle.dataset.selected === 'true' && labels?.dataset.garageSelectedLabel && current.textContent !== labels.dataset.garageSelectedLabel) current.textContent = labels.dataset.garageSelectedLabel;
      });
    };
    finderObserver = new MutationObserver(sync);
    finderObserver.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'data-initialized', 'data-selected'] });
    sync();
  }

  function connectDrawer() {
    const drawer = document.querySelector('#MenuDrawer.rival-mobile');
    if (!drawer || drawer.dataset.rivalNavReady) return;
    drawer.dataset.rivalNavReady = 'true';
    connectModelSearch(drawer);
    const menus = drawer.querySelector('.menu-drawer__menus');
    const branches = [...menus.querySelectorAll('details[is="menu-drawer-details"]')];
    function focusPanel(branch) {
      const panel = branch?.querySelector('.menu-drawer__submenu');
      const focus = panel?.querySelector('button') || drawer.querySelector('.rival-mobile__close');
      [...menus.children].forEach((child) => { if (!child.classList.contains('rival-mobile__list')) child.inert = !!branch; });
      menus.querySelectorAll('.rival-mobile__list > li').forEach((li) => {
        li.inert = !!branch && !li.contains(branch);
        const summary = li.querySelector('details > summary');
        if (summary) summary.inert = !!branch;
      });
      if (drawer.open) focus.focus();
    }
    branches.forEach((branch) => {
      branch.addEventListener('toggle', () => {
        if (branch.open) {
          menus.scrollTop = 0;
          focusPanel(branch);
        }
      });
      branch.querySelector('.rival-mobile__back').addEventListener('click', () => {
        focusPanel(null);
        branch.querySelector('summary').focus();
      });
    });
    drawer.querySelectorAll('.rival-mobile__accordion').forEach((accordion) => {
      accordion.addEventListener('toggle', () => {
        if (accordion.open) accordion.closest('ul').querySelectorAll('.rival-mobile__accordion').forEach((other) => { if (other !== accordion) other.open = false; });
      });
    });
    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !drawer.open) return;
      const items = [...drawer.querySelectorAll('summary,a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),[tabindex="0"]')].filter((node) => !node.closest('[inert],[hidden]') && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
      if (!items.length) return;
      event.preventDefault();
      event.stopPropagation();
      const index = items.indexOf(document.activeElement);
      items[(index + (event.shiftKey ? -1 : 1) + items.length) % items.length].focus();
    });
    drawer.addEventListener('drawer:handleAfterHide', () => {
      focusPanel(null);
      drawer.querySelectorAll('.rival-mobile__accordion').forEach((item) => { item.open = false; });
    });
    window.matchMedia('(min-width:1024px)').addEventListener('change', (event) => { if (event.matches && drawer.isConnected && drawer.open) drawer.hide(); });
  }

  document.addEventListener('click', async (event) => {
    const action = event.target.closest('[data-nav-vehicle-action]');
    if (!action) return;
    const root = document.querySelector('[data-rival-vehicle-finder][data-indicator="true"][data-initialized="true"]');
    if (!root) return;
    const active = root.querySelector('[data-rival-active]');
    const selected = active && !active.hidden;
    const trigger = root.querySelector(selected ? '[data-rival-change]' : '[data-rival-open-finder]');
    if (!trigger || trigger.disabled) return;
    event.preventDefault();
    document.querySelectorAll('rival-nav-menu').forEach((menu) => menu.close());
    const drawer = action.closest('menu-drawer');
    if (drawer?.open) {
      await drawer.hide();
      await new Promise((resolve) => setTimeout(resolve, 0));
    }
    const focusTarget = drawer ? document.querySelector('.menu-drawer-button') : action.closest('rival-nav-menu')?.querySelector('summary');
    focusTarget?.focus({ preventScroll: true });
    trigger.click();
  });
  function mount() { connectDrawer(); connectVehicle(); }
  mount();
  ['DOMContentLoaded', 'rival:finder-ready', 'shopify:section:load'].forEach((event) => document.addEventListener(event, mount));
})();
